import { VGDisclaimerContent } from '../../../../components/VGDisclaimerContent/VGDisclaimerContent';
import { FunctionComponent } from 'react';
import { useSuburbPageQuery } from '../../../graphql/useSuburbPageQuery';

export const SuburbPageVGDisclaimerModalContentWithData: FunctionComponent = () => {
  const vgDisclaimerHtml = useSuburbPageQuery()?.data?.suburbPageBySlug?.vgDisclaimerHtml;

  return <VGDisclaimerContent vgDisclaimerHtml={vgDisclaimerHtml ?? null} />;
};
